// extracted by mini-css-extract-plugin
export default {"modalFullContent":"LeadProfileTab_modalFullContent__-ziNn","selectTypeWrapper":"LeadProfileTab_selectTypeWrapper__HqlRT"};